// extracted by mini-css-extract-plugin
export default {"pwaInstallPrompt":"styles_pwaInstallPrompt__X4ROK","visible":"styles_visible__yccmh","hidden":"styles_hidden__TQGeb"};